import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Color } from '@diritto/common/style/color';

interface DividerProps {
  className?: string;
  color?: string;
  position?: 'top' | 'bottom';
}

export const Divider = ({ className, color, position }: DividerProps) => (
  <StyledContainer className={className} color={color} position={position} />
);

const StyledContainer = styled.div(
  ({ color = Color.Gray300, position = 'bottom' }: DividerProps) => css`
    position: absolute;
    top: ${position === 'top' ? 0 : 'initial'};
    left: 0;
    bottom: ${position === 'bottom' ? 0 : 'initial'};
    height: 1px;
    width: 100%; // 100vw 필요한 곳에서만 적절하게 사용할것.
    background-color: ${color};
  `,
);
